/**
 * Wrapper for PaymentQuickCreateDialog that handles create mutation internally.
 * Used by QuickCreateMenu to create new payments.
 */

import { useTranslation } from 'react-i18next';
import { PaymentQuickCreateDialog } from '../../modules/accounting/components/PaymentQuickCreateDialog';
import { useCreatePayment } from '../../modules/accounting/hooks/usePayments';
import { useNotification } from '../../shared/context/NotificationContext';
import type { PaymentCreate } from '../../modules/accounting/types';

interface QuickCreatePaymentFormProps {
  open: boolean;
  onClose: () => void;
}

export function QuickCreatePaymentForm({ open, onClose }: QuickCreatePaymentFormProps) {
  const { t } = useTranslation('accounting');
  const { showSuccess } = useNotification();
  const createPayment = useCreatePayment();

  const handleSubmit = async (data: PaymentCreate) => {
    try {
      await createPayment.mutateAsync(data);
      showSuccess(t('payments.createSuccess'));
      onClose();
    } catch {
      // The global mutation-error handler shows the specific translated toast.
    }
  };

  return (
    <PaymentQuickCreateDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={createPayment.isPending}
    />
  );
}
